import React from "react";
import "./Popup.scss";

class Popup extends React.Component {
  render() {
    if (this.props.popupShow) {
      return (
        <div className="backgroundDisabler">
          <div className="pendingRow">
            <div className="col-md-4"></div>
            <div className="col-md-4">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                      {this.props.popupTitle}
                    </h5>
                    <button
                      onClick={this.props.updateStatus}
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    {this.props.popupLines.map((m, i) => (
                      <p key={`popupLines-${i}`} className="mb-0">
                        {m}
                      </p>
                    ))}
                  </div>
                  <div className="modal-footer">
                    <button
                      onClick={this.props.updateStatus}
                      type="button"
                      className="btn btn-secondary"
                      data-dismiss="modal"
                    >
                     Close
                    </button>
                   {this.props.behaviour != undefined  &&
                    <button
                      onClick={this.props.behaviour}
                      type="button"
                      className="btn btn-secondary"
                      data-dismiss="modal"
                    >
                     OK
                    </button>

                   }
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4"></div>
          </div>
        </div>
      );
    } else {
      return <div style={{ display: "block" }}></div>;
    }
  }
}

export default Popup;
